import { Col as AntdCol, ColProps } from 'antd';
import React, { FunctionComponent } from 'react';

export type { ColProps };

export const Col: FunctionComponent<ColProps> = (props) => {
  return <AntdCol className="the5ers-col" {...props} />;
};
